import { render, staticRenderFns } from "./MineListCardView.vue?vue&type=template&id=24b6dcd7&scoped=true"
import script from "./MineListCardView.vue?vue&type=script&lang=js"
export * from "./MineListCardView.vue?vue&type=script&lang=js"
import style0 from "./MineListCardView.vue?vue&type=style&index=0&id=24b6dcd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b6dcd7",
  null
  
)

export default component.exports